<p-toast class="hidden sm:block"></p-toast>
<p-toast position="center" class="sm:hidden"></p-toast>
<router-outlet></router-outlet>
